var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0375,
    d: "M35.643 21.4434C54.3805 28.3531 26.0628 49.107 23.2349 35.4252C21.8284 28.6187 8.62854 32.8285 9.0269 25.8056C9.42034 18.7828 15.3662 19.3877 21.2677 15.95C28.6152 11.6173 30.6857 19.6139 35.643 21.4434Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.075,
    d: "M35.7908 21.0892C53.3676 28.3383 26.9974 48.738 23.245 35.73C21.3958 29.317 8.41239 32.0612 9.20418 25.2744C9.99106 18.4876 15.7697 18.5515 21.5434 15.7089C28.7384 12.1631 31.0007 19.1171 35.7908 21.0892Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1125,
    d: "M35.9335 20.7401C52.3497 28.2941 27.9418 48.3939 23.2451 36.035C20.9583 30.0203 8.18137 31.294 9.37152 24.7384C10.5469 18.1926 16.1583 17.6958 21.8091 15.468C28.8516 12.6893 31.3155 18.6106 35.9335 20.7401Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M36.0807 20.386C51.3314 28.2055 28.9103 48.0545 23.2546 36.3399C20.5448 30.7334 7.95974 30.5268 9.54825 24.2072C11.1171 17.8975 16.5465 16.845 22.0891 15.227C28.9595 13.2205 31.625 18.0991 36.0807 20.386Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M36.2235 20.0318C50.3135 28.0727 29.899 47.72 23.2597 36.6447C20.1418 31.4415 7.7337 29.7596 9.72056 23.6711C11.6828 17.5974 16.9303 15.9942 22.3598 14.986C29.0679 13.7466 31.9301 17.5827 36.2235 20.0318Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.225,
    d: "M36.371 19.6827C49.3053 27.9055 30.917 47.3905 23.2646 36.9546C19.7483 32.1596 7.51234 28.9973 9.89264 23.1449C12.2483 17.3073 17.3139 15.1434 22.6302 14.7548C29.1711 14.2729 32.235 17.0515 36.371 19.6827Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2625,
    d: "M36.5135 19.3286C48.3069 27.6842 31.9546 47.0463 23.2694 37.2595C19.3695 32.8628 7.28601 28.2301 10.0647 22.6138C12.8138 17.0122 17.6925 14.2876 22.9055 14.5139C29.2694 14.7893 32.5398 16.5155 36.5135 19.3286Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.6612 18.9794C47.3332 27.4187 33.0219 46.6922 23.2794 37.5694C19.0057 33.5661 7.06485 27.4679 10.2419 22.0827C13.3844 16.7172 18.0713 13.427 23.1811 14.2778C29.3679 15.3057 32.8449 15.9598 36.6612 18.9794Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3375,
    d: "M36.8038 18.6254C46.3791 27.1089 34.0989 46.3087 23.2793 37.8694C18.6368 34.2498 6.83853 26.6958 10.409 21.5467C13.945 16.4221 18.4499 12.5615 23.4515 14.0369C29.4661 15.8123 33.1595 15.3943 36.8038 18.6254Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M36.9514 18.2761C45.4595 26.7596 35.1957 45.9053 23.2893 38.1792C18.2828 34.9284 6.61736 25.9334 10.5862 21.0154C14.5107 16.127 18.8336 11.686 23.727 13.7958C29.5696 16.3188 33.4843 14.8188 36.9514 18.2761Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4125,
    d: "M37.0938 17.9221C44.5691 26.3712 36.2872 45.4726 23.2939 38.4841C17.9235 35.5973 6.39082 25.1663 10.758 20.4843C15.076 15.8319 19.2169 10.8156 23.9972 13.5598C29.6725 16.8155 33.8233 14.2238 37.0938 17.9221Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M37.2414 17.5729C43.7282 25.9629 37.384 45.0201 23.2989 38.7939C17.5645 36.2612 6.16467 24.4039 10.9302 19.9581C15.6416 15.5417 19.6006 9.94508 24.2677 13.3237C29.7808 17.3171 34.1824 13.6139 37.2414 17.5729Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4875,
    d: "M37.384 17.2188C42.9266 25.54 38.4709 44.5382 23.3039 39.0989C17.2056 36.9104 5.94342 23.6368 11.1024 19.4221C16.2072 15.2418 19.9941 9.0648 24.5432 13.0828C29.8989 17.8139 34.571 12.9943 37.384 17.2188Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.525,
    d: "M37.5317 16.8697C42.1791 25.1171 39.5529 44.0464 23.3138 39.4087C16.8417 37.5596 5.72218 22.8696 11.2746 18.8959C16.7729 14.9517 20.3876 8.19927 24.8138 12.8468C30.017 18.3106 34.994 12.3648 37.5317 16.8697Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M37.6745 16.5155C41.4761 24.7088 40.6203 43.5398 23.3189 39.7087C16.4731 38.1939 5.49613 22.0974 11.4469 18.3597C17.3337 14.6516 20.7861 7.31888 25.0844 12.6057C30.1352 18.8122 35.4565 11.7303 37.6745 16.5155Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.8216 16.1614C40.8265 24.3351 41.6822 43.0185 23.3234 40.0136C16.094 38.8284 5.27443 21.3302 11.6186 17.8237C17.8989 14.3516 21.1841 6.44348 25.3594 12.3647C30.2578 19.3138 35.9577 11.1008 37.8216 16.1614Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0011 40.7021C14.5947 67.9575 -2.23953 19.2942 15.4947 19.8597C24.3766 20.1401 21.3569 -0.589211 30.0421 1.09766C38.7272 2.78452 35.6092 11.3713 38.7862 21.0155C42.755 33.0596 31.4683 33.6596 28.0011 40.7021Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M28.3797 40.9923C14.8307 66.5313 -2.05763 20.7154 15.1258 19.7958C23.6634 19.3384 22.3306 -0.731849 30.6272 1.4714C38.9239 3.66974 36.5288 12.1336 38.9927 21.4679C42.1107 33.0989 31.96 34.2497 28.3797 40.9923Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M28.7633 41.2824C15.111 65.1051 -1.90026 22.1465 14.7618 19.7318C22.9404 18.5466 23.3142 -0.879431 31.2223 1.84513C39.1255 4.55493 37.4288 12.9007 39.2091 21.9154C41.4271 33.1481 32.4567 34.8349 28.7633 41.2824Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M29.1419 41.5775C15.4207 63.6838 -1.77742 23.6072 14.3929 19.6729C22.2026 17.7696 24.2928 -1.02199 31.8074 2.22388C39.3172 5.45007 38.3336 13.668 39.4156 22.3728C40.7631 33.1875 32.9632 35.4202 29.1419 41.5775Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.5257 41.8677C15.78 62.2626 -1.66901 25.0974 14.0243 19.6041C21.4602 17.0025 25.2766 -1.17439 32.3929 2.58786C39.5092 6.32552 39.2387 14.4156 39.6223 22.8155C40.0994 33.2219 33.4798 36.0006 29.5257 41.8677Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M29.9043 42.1578C16.1782 60.8461 -1.57074 26.6219 13.6553 19.54C20.7126 16.2646 26.2552 -1.31712 32.983 2.96644C39.7058 7.21557 40.1534 15.1778 39.8337 23.2678C39.4403 33.2563 34.0059 36.5759 29.9043 42.1578Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.2832 42.448C16.6358 59.4445 -1.47713 28.1858 13.2866 19.4761C19.9652 15.5368 27.234 -1.46956 33.5684 3.3353C39.8978 8.10082 41.0634 15.9253 40.0404 23.7154C38.7814 33.2858 34.5421 37.1513 30.2832 42.448Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M30.6665 42.7431C17.1469 58.0675 -1.3594 29.7941 12.9224 19.4172C19.2272 14.8336 28.2173 -1.61212 34.1631 3.70913C40.0942 8.98612 41.9876 16.6778 40.2565 24.163C38.132 33.3104 35.0877 37.7268 30.6665 42.7431Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.0453 43.0332C17.7126 56.715 -1.22159 31.4268 12.5487 19.3532C18.4946 14.1401 29.1912 -1.75969 34.7436 4.08286C40.2812 9.87132 42.9025 17.4303 40.4583 24.6154C37.4878 33.3399 35.6534 38.3071 31.0453 43.0332Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M31.4239 43.3235C18.3322 55.3971 -1.05443 33.0793 12.1798 19.2893C17.7765 13.4566 30.1698 -1.90717 35.3337 4.45669C40.4779 10.7566 43.8369 18.1828 40.6697 25.063C36.8484 33.3695 36.2288 38.8924 31.4239 43.3235Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.8077 43.6184C19.0062 54.1282 -0.852603 34.7513 11.8161 19.2302C17.0783 12.7827 31.1536 -2.04989 35.924 4.83528C40.6748 11.6516 44.7715 18.94 40.8764 25.5203C36.2142 33.4038 36.8289 39.4923 31.8077 43.6184Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M32.1862 43.9087C19.724 52.9036 -0.621637 36.4235 11.4471 19.1663C16.3847 12.1041 32.1321 -2.19737 36.5091 5.20418C40.8664 12.532 45.7008 19.6975 41.0828 25.9679C35.5845 33.4383 37.4386 40.1169 32.1862 43.9087Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.5649 44.1988C20.4765 51.7429 -0.365917 38.0955 11.0733 19.1023C15.7011 11.4254 33.1108 -2.34497 37.0943 5.57789C41.0582 13.4171 46.6352 20.4597 41.2893 26.4154C34.955 33.4825 38.0681 40.766 32.5649 44.1988Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.9484 44.489C21.2535 50.6512 -0.0856184 39.7628 10.7093 19.0385C15.0322 10.7418 34.0943 -2.49244 37.6844 5.95172C41.2549 14.3074 47.5794 21.227 41.5008 26.8679C34.3304 33.5268 38.7172 41.4497 32.9484 44.489Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.327 44.7841C22.0255 49.6381 0.214233 41.4251 10.3403 18.9795C14.3633 10.0583 35.0729 -2.63504 38.2745 6.32551C41.4515 15.1926 48.5186 21.9991 41.7121 27.3154C33.7007 33.5809 39.3712 42.1874 33.327 44.7841Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.7109 45.0742C22.7782 48.6938 0.534211 43.0726 9.97673 18.9155C13.7095 9.36475 36.0568 -2.78265 38.8649 6.69921C41.6485 16.0778 49.4582 22.7761 41.9239 27.7678C33.0715 33.635 40.0256 42.984 33.7109 45.0742Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.0894 45.3644C23.4666 47.8184 0.853711 44.7103 9.60279 18.8515C13.0503 8.67133 37.0303 -2.92526 39.45 7.07299C41.8401 16.968 50.3876 23.5531 42.1303 28.2203C32.437 33.694 40.6697 43.8447 34.0894 45.3644Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.0944 33.5318C-17.9823 30.9105 19.7976 -8.06448 26.9779 11.1697C30.5729 20.7991 48.4645 8.64189 50.6776 18.6696C52.8907 28.6974 43.576 29.0515 36.0171 36.6104C26.5795 46.0382 21.1206 34.2055 13.0944 33.5318Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2125,
    d: "M12.9861 34.0628C-16.5316 30.5563 18.5631 -7.24818 26.8745 10.7467C31.0056 19.6974 49.0251 9.6254 50.5841 19.4564C52.148 29.2826 43.2661 30.3645 35.6875 37.0234C26.2598 45.3643 20.7959 34.9874 12.9861 34.0628Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.225,
    d: "M12.8831 34.594C-15.0608 30.2416 17.3142 -6.45145 26.7715 10.3238C31.4288 18.586 49.586 10.609 50.4909 20.2433C51.4105 29.8727 42.9369 31.6481 35.3583 37.4366C25.9157 44.6562 20.4765 35.7792 12.8831 34.594Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2375,
    d: "M12.7746 35.13C-13.571 29.976 16.0303 -5.67446 26.6728 9.90077C31.8416 17.4646 50.1463 11.5926 50.402 21.0351C50.6725 30.4628 42.6267 32.9513 35.0334 37.8546C25.5908 43.9578 20.1663 36.5759 12.7746 35.13Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.6713 35.6612C-12.0711 29.7596 14.7122 -4.90228 26.5695 9.4828C32.2301 16.3483 50.7069 12.5811 50.3135 21.8269C49.9397 31.053 42.3218 34.2497 34.7136 38.2726C25.2662 43.2644 19.8663 37.3776 12.6713 35.6612Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2625,
    d: "M12.5682 36.1923C-10.5561 29.5973 13.36 -4.13021 26.4664 9.05981C32.5992 15.2319 51.2678 13.5696 50.2203 22.6137C49.2022 31.6382 42.0171 35.548 34.3844 38.6906C24.9517 42.5709 19.5714 38.189 12.5682 36.1923Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.275,
    d: "M12.4602 36.7284C-9.04117 29.5039 11.9635 -3.34326 26.3633 8.64185C32.9485 14.1254 51.8237 14.5582 50.127 23.4105C48.4598 32.2334 41.7124 36.8563 34.0551 39.1136C24.6421 41.8824 19.2815 39.0202 12.4602 36.7284Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2875,
    d: "M12.3567 37.2596C-7.52172 29.4793 10.542 -2.5367 26.2648 8.21892C33.2926 13.0238 52.3891 15.5418 50.0383 24.1974C47.7268 32.8236 41.422 38.1596 33.7303 39.5268C24.3369 41.194 18.996 39.8612 12.3567 37.2596Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.2536 37.7906C-6.01669 29.5186 9.09133 -1.69582 26.1616 7.79587C33.6173 11.9417 52.9498 16.5253 49.945 24.9891C46.9843 33.4136 41.127 39.4726 33.4009 39.9447C24.0371 40.5152 18.7109 40.7168 12.2536 37.7906Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M12.1455 38.3267C-4.52649 29.6366 7.62583 -0.815466 26.0584 7.37788C33.9321 10.8746 53.5106 17.5138 49.8565 25.781C46.2516 34.0038 40.8369 40.7906 33.0764 40.3628C23.7322 39.8464 18.4257 41.5972 12.1455 38.3267Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.325,
    d: "M12.0423 38.8578C-3.06085 29.8186 6.15544 0.104149 25.9552 6.95489C34.2518 9.82207 54.0664 18.5023 49.7631 26.5678C45.514 34.589 40.5419 42.1135 32.7469 40.7807C23.4323 39.1824 18.1258 42.502 12.0423 38.8578Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3375,
    d: "M11.9387 39.394C-1.63986 30.0695 4.69449 1.05836 25.8565 6.53207C34.5712 8.7845 54.6316 19.486 49.6743 27.3597C44.776 35.1842 40.2465 43.4464 32.422 41.1989C23.1222 38.5235 17.8157 43.4267 11.9387 39.394Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.8303 39.925C-0.267885 30.3645 3.23371 2.04677 25.7531 6.10902C34.8956 7.76146 55.1921 20.4695 49.5807 28.1465C44.0382 35.7693 39.9464 44.7742 32.0924 41.6119C22.8122 37.8742 17.4762 44.3856 11.8303 39.925Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3625,
    d: "M11.7275 40.4562C1.04563 30.7039 1.79808 3.05994 25.6503 5.68614C35.2305 6.74351 55.7532 21.4532 49.4926 28.9334C43.3009 36.3546 39.6419 46.107 31.7731 42.0251C22.4929 37.2202 17.1077 45.3693 11.7275 40.4562Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M11.6241 40.9923C2.28978 31.0629 0.376689 4.09268 25.5518 5.26807C35.5746 5.73528 56.3138 22.4416 49.404 29.7301C42.568 36.9497 39.332 47.4496 31.4485 42.448C22.1682 36.571 16.6896 46.3774 11.6241 40.9923Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3875,
    d: "M11.5157 41.5234C3.44528 31.412 -1.03008 5.13528 25.4483 4.84512C35.9236 4.732 56.8742 23.4301 49.3103 30.517C41.8301 37.5349 39.017 48.7823 31.1187 42.866C21.8434 35.9169 16.2123 47.4102 11.5157 41.5234Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.4127 42.0545C4.52753 31.7317 -2.41174 6.19265 25.3453 4.42217C36.278 3.72874 57.4351 24.4137 49.2172 31.3038C41.0927 38.13 38.6976 50.1151 30.7895 43.284C21.5093 35.2628 15.6766 48.4479 11.4127 42.0545Z",
    stroke: "#007BD5",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/NavLogo.98ff7108d5f07dbfd7effa2b91faa2b0.svg";
export { ForwardRef as ReactComponent };